import { loadable } from "../../../components/loadable";

export default loadable(() => import(/* webpackChunkName: "ReferralReceivedRewardModal" */ './ReferralReceivedRewardModal'));
